var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-setting-view" },
    [
      _vm._m(0),
      _c("el-divider"),
      _c(
        "el-form",
        {
          ref: "writeSettingForm",
          attrs: {
            model: _vm.writeSettingForm,
            rules: _vm.settingRules,
            "label-position": "left",
          },
        },
        [
          _c("section", [
            _c(
              "div",
              { staticClass: "setting-item" },
              [
                _c(
                  "p",
                  { staticClass: "label" },
                  [
                    _vm._v(" 会员答题次数限制 "),
                    _c("el-tooltip", { attrs: { placement: "top-start" } }, [
                      _c("i", { staticClass: "el-icon-question" }),
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            " 1、目前会员规则为用户进入品牌小程序则会生成会员卡号 "
                          ),
                          _c("br"),
                          _vm._v(
                            " 2、此属性用于限制品牌会员餐后问卷答题次数，配置餐后跳转问卷时需拼接参数：订单号、会员卡号后生效 "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _c("el-switch", {
                  model: {
                    value: _vm.writeSettingForm.userCardNoLimitStatus,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.writeSettingForm,
                        "userCardNoLimitStatus",
                        $$v
                      )
                    },
                    expression: "writeSettingForm.userCardNoLimitStatus",
                  },
                }),
              ],
              1
            ),
            _vm.writeSettingForm.userCardNoLimitStatus
              ? _c("div", { staticClass: "item-config-box" }, [
                  _c(
                    "div",
                    { staticClass: "item-config-row" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "item-config-col1",
                          model: {
                            value: _vm.writeSettingForm.userCardNoLimitType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.writeSettingForm,
                                "userCardNoLimitType",
                                $$v
                              )
                            },
                            expression: "writeSettingForm.userCardNoLimitType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "每个订单每个用户",
                              value: "EVERY_ORDER",
                            },
                          }),
                          _c("el-option", {
                            attrs: { label: "每个订单", value: "ONLY_ORDER" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-config-col2" },
                        [
                          _vm._v(" 答题 "),
                          _c("el-input-number", {
                            attrs: { min: 1 },
                            model: {
                              value: _vm.writeSettingForm.userCardNoLimitCount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.writeSettingForm,
                                  "userCardNoLimitCount",
                                  $$v
                                )
                              },
                              expression:
                                "writeSettingForm.userCardNoLimitCount",
                            },
                          }),
                          _vm._v(" 次 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-config-row" },
                    [
                      _c("div", { staticClass: "item-config-col1" }, [
                        _vm._v("重复答题提示："),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "item-config-col2",
                          on: { change: _vm.changePromptType },
                          model: {
                            value:
                              _vm.writeSettingForm.userCardNoLimitPromptType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.writeSettingForm,
                                "userCardNoLimitPromptType",
                                $$v
                              )
                            },
                            expression:
                              "writeSettingForm.userCardNoLimitPromptType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "TEXT" } }, [
                            _vm._v("提示文案"),
                          ]),
                          _c("el-radio", { attrs: { label: "PICTURE" } }, [
                            _vm._v("上传图片"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm.writeSettingForm.userCardNoLimitPromptType === "TEXT"
                        ? _c("el-input", {
                            attrs: {
                              placeholder: "您已成功提交答卷，无需重复提交",
                            },
                            model: {
                              value: _vm.writeSettingForm.userCardNoLimitText,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.writeSettingForm,
                                  "userCardNoLimitText",
                                  $$v
                                )
                              },
                              expression:
                                "writeSettingForm.userCardNoLimitText",
                            },
                          })
                        : _vm.writeSettingForm.userCardNoLimitPromptType ===
                          "PICTURE"
                        ? _c("div", { staticClass: "flex-row" }, [
                            _c(
                              "div",
                              { staticStyle: { "margin-right": "60px" } },
                              [
                                _vm._v(" 手机版背景设置 "),
                                _c("upload-image", {
                                  attrs: {
                                    "already-file":
                                      _vm.writeSettingForm
                                        .userCardNoLimitMobilePictureUrl,
                                    "img-size": 5,
                                    "url-suffix": "/common/upload",
                                  },
                                  on: {
                                    uploadSuccess: _vm.changePictureUrl,
                                    removeSuccess: function ($event) {
                                      _vm.writeSettingForm.userCardNoLimitMobilePictureUrl =
                                        ""
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "fs12 color-minor" }, [
                                  _vm._v("建议尺寸：750*1448px"),
                                ]),
                                _c("div", { staticClass: "fs12 color-minor" }, [
                                  _vm._v("建议格式：JPG/JPEG/PNG/GIF"),
                                ]),
                                _c("div", { staticClass: "fs12 color-minor" }, [
                                  _vm._v("小于5M"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _vm._v(" 电脑版背景设置 "),
                                _c("upload-image", {
                                  attrs: {
                                    "already-file":
                                      _vm.writeSettingForm
                                        .usercardNolimitPcpictureurl,
                                    "img-size": 10,
                                    "url-suffix": "/common/upload",
                                  },
                                  on: {
                                    uploadSuccess: _vm.changePcPictureUrl,
                                    removeSuccess: function ($event) {
                                      _vm.writeSettingForm.usercardNolimitPcpictureurl =
                                        ""
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "fs12 color-minor" }, [
                                  _vm._v("建议尺寸：1920*1080px"),
                                ]),
                                _c("div", { staticClass: "fs12 color-minor" }, [
                                  _vm._v("建议格式：JPG/JPEG/PNG/GIF"),
                                ]),
                                _c("div", { staticClass: "fs12 color-minor" }, [
                                  _vm._v("小于10M"),
                                ]),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 密码填写 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        content: "开启后需要输入密码才能进入填写页面",
                        effect: "dark",
                        placement: "top-start",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.writeSettingForm.passwordWriteStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.writeSettingForm, "passwordWriteStatus", $$v)
                  },
                  expression: "writeSettingForm.passwordWriteStatus",
                },
              }),
            ],
            1
          ),
          _vm.writeSettingForm.passwordWriteStatus
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        rules: [
                          {
                            required: true,
                            message: "请输入填写密码",
                            trigger: "blur",
                          },
                        ],
                        prop: "writePassword",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入填写密码" },
                        model: {
                          value: _vm.writeSettingForm.writePassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.writeSettingForm, "writePassword", $$v)
                          },
                          expression: "writeSettingForm.writePassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 每个IP答题次数限制 "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "top-start",
                        content:
                          " 此属性用于指定每一个IP地址只能提交一次表单，可以防止用户在同一台计算机上进行多次提交。",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.writeSettingForm.ipWriteCountLimitStatus,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.writeSettingForm,
                      "ipWriteCountLimitStatus",
                      $$v
                    )
                  },
                  expression: "writeSettingForm.ipWriteCountLimitStatus",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 每台设备次数限制 "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "top-start",
                        content:
                          "此功能依赖浏览器的本地存储，不能保证100%有效。",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.writeSettingForm.deviceWriteCountLimitStatus,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.writeSettingForm,
                      "deviceWriteCountLimitStatus",
                      $$v
                    )
                  },
                  expression: "writeSettingForm.deviceWriteCountLimitStatus",
                },
              }),
            ],
            1
          ),
          _vm.writeSettingForm.deviceWriteCountLimitStatus
            ? _c(
                "div",
                { staticClass: "item-config-box" },
                [
                  _c("div", { staticClass: "item-config-row" }, [
                    _c(
                      "div",
                      [
                        _vm._v(" 答题 "),
                        _c("el-input-number", {
                          attrs: { min: 1 },
                          model: {
                            value: _vm.writeSettingForm.deviceWriteCountLimit,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.writeSettingForm,
                                "deviceWriteCountLimit",
                                $$v
                              )
                            },
                            expression:
                              "writeSettingForm.deviceWriteCountLimit",
                          },
                        }),
                        _vm._v(" 次 "),
                      ],
                      1
                    ),
                  ]),
                  _c("el-input", {
                    staticClass: "item-config-col2",
                    attrs: {
                      placeholder:
                        "该设备已经提交过数据，不可重复提交，有问题请与表单发布者联系",
                    },
                    model: {
                      value: _vm.writeSettingForm.deviceWriteCountLimitText,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.writeSettingForm,
                          "deviceWriteCountLimitText",
                          $$v
                        )
                      },
                      expression: "writeSettingForm.deviceWriteCountLimitText",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 设定答题次数上限 "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "top-start",
                        content:
                          "当答题次数达到上限后，表单将无法提交数据，进入将显示提示文案",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.writeSettingForm.totalWriteCountLimitStatus,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.writeSettingForm,
                      "totalWriteCountLimitStatus",
                      $$v
                    )
                  },
                  expression: "writeSettingForm.totalWriteCountLimitStatus",
                },
              }),
            ],
            1
          ),
          _vm.writeSettingForm.totalWriteCountLimitStatus
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value:
                                  _vm.writeSettingForm
                                    .totalWriteCountLimitDateType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.writeSettingForm,
                                    "totalWriteCountLimitDateType",
                                    $$v
                                  )
                                },
                                expression:
                                  "writeSettingForm.totalWriteCountLimitDateType",
                              },
                            },
                            _vm._l(_vm.dateRangeList, function (d) {
                              return _c(
                                "el-option",
                                {
                                  key: d.value,
                                  attrs: { label: d.label, value: d.value },
                                },
                                [_vm._v(" " + _vm._s(d.label) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm._v(" 答题 "),
                          _c("el-input-number", {
                            attrs: { min: 1 },
                            model: {
                              value: _vm.writeSettingForm.totalWriteCountLimit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.writeSettingForm,
                                  "totalWriteCountLimit",
                                  $$v
                                )
                              },
                              expression:
                                "writeSettingForm.totalWriteCountLimit",
                            },
                          }),
                          _vm._v(" 次 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticClass: "mt10",
                    attrs: {
                      placeholder:
                        "该表单收集数据已经达到上限，有问题请与表单发布者联系",
                    },
                    model: {
                      value: _vm.writeSettingForm.totalWriteCountLimitText,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.writeSettingForm,
                          "totalWriteCountLimitText",
                          $$v
                        )
                      },
                      expression: "writeSettingForm.totalWriteCountLimitText",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 允许填写时间 "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "top-start",
                        content:
                          "当进入设置的时间范围内，用户能访问表单并提交数据，否则将会显示对应文案",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.writeSettingForm.writeInterviewTimeStatus,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.writeSettingForm,
                      "writeInterviewTimeStatus",
                      $$v
                    )
                  },
                  expression: "writeSettingForm.writeInterviewTimeStatus",
                },
              }),
            ],
            1
          ),
          _vm.writeSettingForm.writeInterviewTimeStatus
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value:
                                  _vm.writeSettingForm
                                    .writeInterviewDayTimeStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.writeSettingForm,
                                    "writeInterviewDayTimeStatus",
                                    $$v
                                  )
                                },
                                expression:
                                  "writeSettingForm.writeInterviewDayTimeStatus",
                              },
                            },
                            [_vm._v(" 限制每天访问的时间范围 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.writeSettingForm.writeInterviewDayTimeStatus
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            { staticClass: "mt10" },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 13 } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "daterange",
                                      "value-format": "yyyy-MM-dd",
                                      "range-separator": "-",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期",
                                    },
                                    model: {
                                      value:
                                        _vm.writeSettingForm
                                          .writeInterviewDateRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.writeSettingForm,
                                          "writeInterviewDateRange",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "writeSettingForm.writeInterviewDateRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { staticClass: "mt10" },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 13 } },
                                [
                                  _c("el-time-picker", {
                                    attrs: {
                                      "is-range": "",
                                      "range-separator": "-",
                                      "value-format": "HH:mm:ss",
                                      "start-placeholder": "开始时间",
                                      "end-placeholder": "结束时间",
                                      placeholder: "选择时间范围",
                                    },
                                    model: {
                                      value:
                                        _vm.writeSettingForm
                                          .writeInterviewTimeRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.writeSettingForm,
                                          "writeInterviewTimeRange",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "writeSettingForm.writeInterviewTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-row",
                        { staticClass: "mt10" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetimerange",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                },
                                model: {
                                  value:
                                    _vm.writeSettingForm
                                      .writeInterviewDateTimeRange,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.writeSettingForm,
                                      "writeInterviewDateTimeRange",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "writeSettingForm.writeInterviewDateTimeRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _c(
                    "div",
                    { staticClass: "checkbox-group mt10" },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value:
                              _vm.writeSettingForm.writeInterviewTimeWhichDays,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.writeSettingForm,
                                "writeInterviewTimeWhichDays",
                                $$v
                              )
                            },
                            expression:
                              "writeSettingForm.writeInterviewTimeWhichDays",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: "2" } }, [
                            _vm._v(" 周一 "),
                          ]),
                          _c("el-checkbox", { attrs: { label: "3" } }, [
                            _vm._v(" 周二 "),
                          ]),
                          _c("el-checkbox", { attrs: { label: "4" } }, [
                            _vm._v(" 周三 "),
                          ]),
                          _c("el-checkbox", { attrs: { label: "5" } }, [
                            _vm._v(" 周四 "),
                          ]),
                          _c("el-checkbox", { attrs: { label: "6" } }, [
                            _vm._v(" 周五 "),
                          ]),
                          _c("el-checkbox", { attrs: { label: "7" } }, [
                            _vm._v(" 周六 "),
                          ]),
                          _c("el-checkbox", { attrs: { label: "1" } }, [
                            _vm._v(" 周日 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticClass: "mt10",
                    attrs: {
                      placeholder:
                        "此表单设置了访问时间，当前时间无法访问，有问题请与表单发布者联系",
                    },
                    model: {
                      value: _vm.writeSettingForm.writeInterviewTimeText,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.writeSettingForm,
                          "writeInterviewTimeText",
                          $$v
                        )
                      },
                      expression: "writeSettingForm.writeInterviewTimeText",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label" }, [_vm._v("只能在微信中填写")]),
              _c("el-switch", {
                on: {
                  change: function (val) {
                    if (!_vm.writeSettingForm.onlyWxWrite && !val) {
                      _vm.writeSettingForm.recordWxUser = false
                    }
                  },
                },
                model: {
                  value: _vm.writeSettingForm.onlyWxWrite,
                  callback: function ($$v) {
                    _vm.$set(_vm.writeSettingForm, "onlyWxWrite", $$v)
                  },
                  expression: "writeSettingForm.onlyWxWrite",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("记录微信用户个人信息"),
              ]),
              _c("el-switch", {
                on: {
                  change: function (val) {
                    if (!_vm.writeSettingForm.onlyWxWrite && val) {
                      _vm.writeSettingForm.onlyWxWrite = true
                    }
                  },
                },
                model: {
                  value: _vm.writeSettingForm.recordWxUser,
                  callback: function ($$v) {
                    _vm.$set(_vm.writeSettingForm, "recordWxUser", $$v)
                  },
                  expression: "writeSettingForm.recordWxUser",
                },
              }),
            ],
            1
          ),
          _c("el-row", [
            _c("p", { staticClass: "project-setting-sub-label" }, [
              _vm._v("* 开启后将会授权登录，提供微信昵称、性别、城市信息"),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("每个微信答题次数限制"),
              ]),
              _c("el-switch", {
                on: {
                  change: function () {
                    _vm.writeSettingForm.recordWxUser = true
                    _vm.writeSettingForm.onlyWxWrite = true
                  },
                },
                model: {
                  value: _vm.writeSettingForm.wxWriteCountLimitStatus,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.writeSettingForm,
                      "wxWriteCountLimitStatus",
                      $$v
                    )
                  },
                  expression: "writeSettingForm.wxWriteCountLimitStatus",
                },
              }),
            ],
            1
          ),
          _vm.writeSettingForm.wxWriteCountLimitStatus
            ? _c(
                "div",
                { staticClass: "item-config-box" },
                [
                  _c(
                    "div",
                    { staticClass: "item-config-row" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "item-config-col1",
                          model: {
                            value:
                              _vm.writeSettingForm.wxWriteCountLimitDateType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.writeSettingForm,
                                "wxWriteCountLimitDateType",
                                $$v
                              )
                            },
                            expression:
                              "writeSettingForm.wxWriteCountLimitDateType",
                          },
                        },
                        _vm._l(_vm.dateRangeList, function (d) {
                          return _c(
                            "el-option",
                            {
                              key: d.value,
                              attrs: { label: d.label, value: d.value },
                            },
                            [_vm._v(" " + _vm._s(d.label) + " ")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-config-col2" },
                        [
                          _vm._v(" 答题 "),
                          _c("el-input-number", {
                            attrs: { min: 1 },
                            model: {
                              value: _vm.writeSettingForm.wxWriteCountLimit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.writeSettingForm,
                                  "wxWriteCountLimit",
                                  $$v
                                )
                              },
                              expression: "writeSettingForm.wxWriteCountLimit",
                            },
                          }),
                          _vm._v(" 次 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticClass: "mt10",
                    attrs: {
                      placeholder:
                        "该微信已经提交过数据，不可重复提交，有问题请与表单发布者联系",
                    },
                    model: {
                      value: _vm.writeSettingForm.wxWriteCountLimitText,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.writeSettingForm,
                          "wxWriteCountLimitText",
                          $$v
                        )
                      },
                      expression: "writeSettingForm.wxWriteCountLimitText",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 每个账号答题次数限制 "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        placement: "top-start",
                        content:
                          " 此属性用于指定每一个账号只能提交指定次表单，防止用户重复提交过指定次数。",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.writeSettingForm.accountWriteCountLimitStatus,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.writeSettingForm,
                      "accountWriteCountLimitStatus",
                      $$v
                    )
                  },
                  expression: "writeSettingForm.accountWriteCountLimitStatus",
                },
              }),
            ],
            1
          ),
          _vm.writeSettingForm.accountWriteCountLimitStatus
            ? _c(
                "div",
                { staticClass: "item-config-box" },
                [
                  _c(
                    "div",
                    { staticClass: "item-config-row" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "item-config-col1",
                          model: {
                            value:
                              _vm.writeSettingForm
                                .accountWriteCountLimitDateType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.writeSettingForm,
                                "accountWriteCountLimitDateType",
                                $$v
                              )
                            },
                            expression:
                              "writeSettingForm.accountWriteCountLimitDateType",
                          },
                        },
                        _vm._l(_vm.dateRangeList, function (d) {
                          return _c(
                            "el-option",
                            {
                              key: d.value,
                              attrs: { label: d.label, value: d.value },
                            },
                            [_vm._v(" " + _vm._s(d.label) + " ")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "item-config-col2" },
                        [
                          _vm._v(" 答题 "),
                          _c("el-input-number", {
                            attrs: { min: 1 },
                            model: {
                              value:
                                _vm.writeSettingForm.accountWriteCountLimit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.writeSettingForm,
                                  "accountWriteCountLimit",
                                  $$v
                                )
                              },
                              expression:
                                "writeSettingForm.accountWriteCountLimit",
                            },
                          }),
                          _vm._v(" 次 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-input", {
                    staticClass: "mt10",
                    attrs: {
                      placeholder:
                        "该账号已经提交过数据，不可重复提交，有问题请与表单发布者联系",
                    },
                    model: {
                      value: _vm.writeSettingForm.accountWriteCountLimitText,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.writeSettingForm,
                          "accountWriteCountLimitText",
                          $$v
                        )
                      },
                      expression: "writeSettingForm.accountWriteCountLimitText",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "submit-btn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveSettingHandle },
                },
                [_vm._v(" 保存设置 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "project-setting-title" }, [
      _vm._v(" 回收设置 "),
      _c("span", { staticClass: "small-font-size ml20 text-secondary-color" }, [
        _vm._v(" 自定义表单收集收集时间，次数，以及限制填写环境等 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }